import React from "react";
import { ArrowUpRight } from "lucide-react";

// Premium hospitality CTA — every variant has solid background + text (high contrast).
export const CTAButton = ({
  children,
  variant = "primary",
  size = "md",
  as: Tag = "button",
  arrow = true,
  className = "",
  ...rest
}) => {
  const base =
    "group relative inline-flex items-center justify-center gap-3 font-sans uppercase tracking-wider2 font-semibold transition-all duration-500 select-none";
  const sizes = {
    sm: "text-[11px] px-6 py-3",
    md: "text-xs px-8 py-4",
    lg: "text-sm px-10 py-5",
  };
  const variants = {
    // PRIMARY — ember on dark text. The star.
    primary:
      "bg-ember text-bone hover:bg-ember-deep border border-ember hover:border-ember-deep",
    // SECONDARY — solid ink on light. Used on bone backgrounds.
    secondary:
      "bg-ink text-bone hover:bg-ember border border-ink hover:border-ember",
    // GHOST — solid bone on ink. Used on dark backgrounds.
    ghost:
      "bg-bone text-ink hover:bg-ember hover:text-bone border border-bone hover:border-ember",
    // LINK — tertiary text link.
    link:
      "bg-transparent text-ink p-0 hover:text-ember border-b-2 border-ink hover:border-ember rounded-none font-semibold",
  };

  return (
    <Tag
      data-testid={`cta-${variant}`}
      className={`${base} ${variant !== "link" ? sizes[size] : ""} ${variants[variant]} ${className}`}
      {...rest}
    >
      <span className="relative z-10">{children}</span>
      {arrow && variant !== "link" && (
        <ArrowUpRight
          className="relative z-10 w-3.5 h-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          strokeWidth={2}
        />
      )}
      {variant === "link" && (
        <ArrowUpRight
          className="w-3 h-3 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          strokeWidth={2}
        />
      )}
    </Tag>
  );
};

export default CTAButton;
